import React from 'react';
import {useNavigate} from "react-router-dom";
import Dropdown, {DropdownItem} from "components/Dropdown";
import {TrashIcon} from "@heroicons/react/solid";
import {Conversation} from "../../../types/Conversation";
import {ChatIcon} from "@heroicons/react/outline";

// Types ----

type ExhibitContextMenuProps = {
  conversation: Conversation
  onDeleteConversation: () => void
  editDisabled?: boolean
  deleteDisabled?: boolean
}

// Component ----

function ConversationContextMenu({
  deleteDisabled,
  onDeleteConversation,
  editDisabled,
  conversation,
}: ExhibitContextMenuProps) {
  const navigate = useNavigate();

  function editConversation() {
    void navigate(`/conversations/${conversation.id}`)
  }

  return (
    <Dropdown>
      {/* TODO: Add conversations permission */}
      {/*{auth.can('conversations:write') &&*/}
        <DropdownItem
          name="Chat"
          icon={ChatIcon}
          onClick={editConversation}
          disabled={!!editDisabled}
        />

      {/* TODO: Add conversations permission */}
      {/*{auth.can('conversations:write') &&*/}
        <DropdownItem
          name="Delete"
          icon={TrashIcon}
          onClick={onDeleteConversation}
          disabled={!!deleteDisabled}
        />
      {/*}*/}
    </Dropdown>
  );
}

export default ConversationContextMenu;